import RecommendationsUpdated from "th/recommendationsUpdated";

export { RecommendationsUpdated };

customElements.define(
  "th-recommendations-updated",
  RecommendationsUpdated.CustomElementConstructor
);
